module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLMenu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "floating-buttons"
  }, [_c('button', {
    staticClass: "fl-button",
    attrs: {
      "disabled": _vm.is_save,
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  })])]), _vm._v(" "), _c('h1', [_vm._v("Nyitvatartás")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2"
  }, [_c('comboboxV2', {
    attrs: {
      "id": "element_type_id",
      "label": "Típus",
      "name": "element_type_id",
      "options": _vm.element_types
    },
    on: {
      "input": _vm.getElements
    },
    model: {
      value: (_vm.element_type_id),
      callback: function($$v) {
        _vm.element_type_id = $$v
      },
      expression: "element_type_id"
    }
  })], 1), _vm._v(" "), (_vm.elements.length > 0) ? _c('div', {
    staticClass: "col-xs-2"
  }, [_c('select2', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "label": "Eszköz",
      "name": "element_id",
      "id": "element_id",
      "options": _vm.elements
    },
    on: {
      "onChange": _vm.getDates
    },
    model: {
      value: (_vm.element_id),
      callback: function($$v) {
        _vm.element_id = $$v
      },
      expression: "element_id"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.element_id != 0),
      expression: "element_id != 0"
    }]
  }, [(_vm.open_warning) ? _c('p', [_c('b', [_vm._v("FIGYELEM!")]), _c('br'), _vm._v("Ebben az ajtóban olyan zár található, melynek hosszan nyitva tartása annak meghibásodását okozhatja."), _c('br'), _vm._v("Ennek az opciónak a használata itt nem javasolt.")]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Nap")]), _vm._v(" "), _vm._l((_vm.items), function(item, i) {
    return (item.deleted == undefined) ? _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('comboboxV2', {
      staticStyle: {
        "width": "200px",
        "margin-right": "15px"
      },
      attrs: {
        "id": 'item_day_' + item.id,
        "label": "Nap",
        "name": 'item_day_' + item.id,
        "options": _vm.days
      },
      model: {
        value: (item.day),
        callback: function($$v) {
          _vm.$set(item, "day", $$v)
        },
        expression: "item.day"
      }
    }), _vm._v(" "), _c('inputbox', {
      staticStyle: {
        "width": "200px",
        "margin-right": "15px"
      },
      attrs: {
        "datepicker": {
          noCalendar: true,
          enableTime: true
        },
        "label": "Időpont -tól",
        "errors": _vm.errors,
        "id": 'item_time_from_' + item.id,
        "name": 'item_time_from_' + item.id
      },
      model: {
        value: (item.time_from),
        callback: function($$v) {
          _vm.$set(item, "time_from", $$v)
        },
        expression: "item.time_from"
      }
    }), _vm._v(" "), _c('inputbox', {
      staticStyle: {
        "width": "200px",
        "margin-right": "15px"
      },
      attrs: {
        "datepicker": {
          noCalendar: true,
          enableTime: true
        },
        "label": "Időpont -ig",
        "errors": _vm.errors,
        "id": 'item_time_to_' + item.id,
        "name": 'item_time_to_' + item.id
      },
      model: {
        value: (item.time_to),
        callback: function($$v) {
          _vm.$set(item, "time_to", $$v)
        },
        expression: "item.time_to"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "form-label"
    }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
      staticClass: "button small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeItem(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('comboboxV2', {
    staticStyle: {
      "width": "200px",
      "margin-right": "15px"
    },
    attrs: {
      "id": "new_item_day",
      "label": "Nap",
      "name": "new_item_day",
      "options": _vm.days
    },
    model: {
      value: (_vm.new_item.day),
      callback: function($$v) {
        _vm.$set(_vm.new_item, "day", $$v)
      },
      expression: "new_item.day"
    }
  }), _vm._v(" "), _c('inputbox', {
    ref: "new_item_time_from",
    staticStyle: {
      "width": "200px",
      "margin-right": "15px"
    },
    attrs: {
      "datepicker": {
        noCalendar: true,
        enableTime: true,
        defaultDate: '00:00'
      },
      "label": "Időpont -tól",
      "errors": _vm.errors,
      "id": "new_item_time_from",
      "name": "new_item_time_from"
    },
    model: {
      value: (_vm.new_item.time_from),
      callback: function($$v) {
        _vm.$set(_vm.new_item, "time_from", $$v)
      },
      expression: "new_item.time_from"
    }
  }), _vm._v(" "), _c('inputbox', {
    ref: "new_item_time_to",
    staticStyle: {
      "width": "200px",
      "margin-right": "15px"
    },
    attrs: {
      "datepicker": {
        noCalendar: true,
        enableTime: true,
        defaultDate: '00:00'
      },
      "label": "Időpont -ig",
      "errors": _vm.errors,
      "id": "new_item_time_to",
      "name": "new_item_time_to"
    },
    model: {
      value: (_vm.new_item.time_to),
      callback: function($$v) {
        _vm.$set(_vm.new_item, "time_to", $$v)
      },
      expression: "new_item.time_to"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "button small",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addItem
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])], 1), _vm._v(" "), _c('h2', [_vm._v("Dátum")]), _vm._v(" "), _vm._l((_vm.items_), function(item, i) {
    return (item.deleted == undefined) ? _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('inputbox', {
      staticStyle: {
        "width": "200px",
        "margin-right": "15px"
      },
      attrs: {
        "datepicker": {
          enableTime: false
        },
        "label": "Dátum -tól",
        "errors": _vm.errors,
        "id": 'item__date_from_' + item.id,
        "name": 'item__date_from_' + item.id
      },
      model: {
        value: (item.date_from),
        callback: function($$v) {
          _vm.$set(item, "date_from", $$v)
        },
        expression: "item.date_from"
      }
    }), _vm._v(" "), _c('inputbox', {
      staticStyle: {
        "width": "200px",
        "margin-right": "15px"
      },
      attrs: {
        "datepicker": {
          noCalendar: true,
          enableTime: true
        },
        "label": "Időpont -tól",
        "errors": _vm.errors,
        "id": 'item__time_from_' + item.id,
        "name": 'item__time_from_' + item.id
      },
      model: {
        value: (item.time_from),
        callback: function($$v) {
          _vm.$set(item, "time_from", $$v)
        },
        expression: "item.time_from"
      }
    }), _vm._v(" "), _c('inputbox', {
      staticStyle: {
        "width": "200px",
        "margin-right": "15px"
      },
      attrs: {
        "datepicker": {
          enableTime: false
        },
        "label": "Dátum -ig",
        "errors": _vm.errors,
        "id": 'item__date_to_' + item.id,
        "name": 'item__date_to' + item.id
      },
      model: {
        value: (item.date_to),
        callback: function($$v) {
          _vm.$set(item, "date_to", $$v)
        },
        expression: "item.date_to"
      }
    }), _vm._v(" "), _c('inputbox', {
      staticStyle: {
        "width": "200px",
        "margin-right": "15px"
      },
      attrs: {
        "datepicker": {
          noCalendar: true,
          enableTime: true
        },
        "label": "Időpont -ig",
        "errors": _vm.errors,
        "id": 'item__time_to_' + item.id,
        "name": 'item__time_to_' + item.id
      },
      model: {
        value: (item.time_to),
        callback: function($$v) {
          _vm.$set(item, "time_to", $$v)
        },
        expression: "item.time_to"
      }
    }), _vm._v(" "), _c('toggle', {
      attrs: {
        "id": "new_item__close",
        "label": "Zárva",
        "errors": _vm.errors,
        "name": 'item__close_' + item.id
      },
      model: {
        value: (item.close),
        callback: function($$v) {
          _vm.$set(item, "close", $$v)
        },
        expression: "item.close"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "form-label"
    }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
      staticClass: "button small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeItem_(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('inputbox', {
    ref: "new_item__date_from",
    staticStyle: {
      "width": "200px",
      "margin-right": "15px"
    },
    attrs: {
      "datepicker": {
        enableTime: false
      },
      "label": "Dátum -tól",
      "errors": _vm.errors,
      "id": "new_item__date_from",
      "name": "new_item__date_from"
    },
    model: {
      value: (_vm.new_item_.date_from),
      callback: function($$v) {
        _vm.$set(_vm.new_item_, "date_from", $$v)
      },
      expression: "new_item_.date_from"
    }
  }), _vm._v(" "), _c('inputbox', {
    ref: "new_item__time_from",
    staticStyle: {
      "width": "200px",
      "margin-right": "15px"
    },
    attrs: {
      "datepicker": {
        noCalendar: true,
        enableTime: true,
        defaultDate: '00:00'
      },
      "label": "Időpont -tól",
      "errors": _vm.errors,
      "id": "new_item__time_from",
      "name": "new_item__time_from"
    },
    model: {
      value: (_vm.new_item_.time_from),
      callback: function($$v) {
        _vm.$set(_vm.new_item_, "time_from", $$v)
      },
      expression: "new_item_.time_from"
    }
  }), _vm._v(" "), _c('inputbox', {
    ref: "new_item__date_to",
    staticStyle: {
      "width": "200px",
      "margin-right": "15px"
    },
    attrs: {
      "datepicker": {
        enableTime: false
      },
      "label": "Dátum -ig",
      "errors": _vm.errors,
      "id": "new_item__date_to",
      "name": "new_item__date_to"
    },
    model: {
      value: (_vm.new_item_.date_to),
      callback: function($$v) {
        _vm.$set(_vm.new_item_, "date_to", $$v)
      },
      expression: "new_item_.date_to"
    }
  }), _vm._v(" "), _c('inputbox', {
    ref: "new_item__time_to",
    staticStyle: {
      "width": "200px",
      "margin-right": "15px"
    },
    attrs: {
      "datepicker": {
        noCalendar: true,
        enableTime: true,
        defaultDate: '00:00'
      },
      "label": "Időpont -ig",
      "errors": _vm.errors,
      "id": "new_item__time_to",
      "name": "new_item__time_to"
    },
    model: {
      value: (_vm.new_item_.time_to),
      callback: function($$v) {
        _vm.$set(_vm.new_item_, "time_to", $$v)
      },
      expression: "new_item_.time_to"
    }
  }), _vm._v(" "), _c('toggle', {
    attrs: {
      "id": "new_item__close",
      "label": "Zárva",
      "errors": _vm.errors,
      "name": "new_item__close"
    },
    model: {
      value: (_vm.new_item_.close),
      callback: function($$v) {
        _vm.$set(_vm.new_item_, "close", $$v)
      },
      expression: "new_item_.close"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('button', {
    staticClass: "button small",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addItem_
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])], 1)], 2)])])], 1), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProgressInfo', {
    attrs: {
      "show": _vm.is_save
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05c757bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/opening.vue
// module id = 277
// module chunks = 0